const tintColor = '#000';
// const myColor = '#5187F7';

export default {
  tintColor,
  loading: '#2f95dc',
  tabIconDefault: 'black',
  tabIconSelected: tintColor,
  tabBar: '#fefefe',
  primaryColor: '#f94c2a',
  primaryDark: '#b3b3b3',
  primaryBackground: '#f6f9fc',
  modalBackground: '#fff',
  fontColor: '#808080',
  errorBackground: 'red',
  errorText: '#fff',
  warningBackground: '#EAEB5E',
  warningText: '#666804',
  noticeBackground: tintColor,
  noticeText: '#fff',

  themeLight: {
    backgroundColorPrimary: '#24344b',
    backgroundColorSecondary: '#ff6959',
    backgroundColorSecondaryLight: '#FFE1DE',
    primaryColor: '#5187F7',
    secondaryColor: '#5FC8B0',
    // headerColor: "#5187F7",
    headerColor: '#24344b',
    headerColorActive: '#739EF8',
    headerTextColor: '#fff',
    backgroundColor: '#F4F4F4',
    // footerBackgroundColor: "#fff",
    footerBackgroundColor: '#24344b',
    // footerTabBackgroundColorActive: "#fff",
    footerTabBackgroundColorActive: '#24344b',
    // footerTabTextColor: "#737373",
    footerTabTextColor: '#FFB0A8',
    // footerTabTextColorActive: "#5187F7",
    footerTabTextColorActive: '#ff6959',
    drawerBackgroudndColor: '#fff',
    drawerTextColor: '#737373',
    fontColorPrimary: '#000',
    fontColorSecondary: '#737373',
    fontColorDisabled: '#d3d3d3',
    fontColorLunch: '#FFDC00',
    fontColorWarning: '#FDA50F',
    // btnWhiteBgColor: "#fff",
    // btnWhiteColor: "#5187F7",
    btnWhiteBgColor: '#ff6959',
    btnWhiteColor: '#24344b',
    btnWhiteDisabledColor: '#fff',
    // btnPrimaryBgColor: "#5187F7",
    btnPrimaryBgColor: '#24344b',
    btnPrimaryColor: '#fff',
    btnSecondaryBgColor: '#ff6959',
    btnSecondaryColor: '#fff',
    inputWhiteLabelColor: '#B8D3FD',
    inputWhiteTextColor: '#fff',
    listItemSelectedBackgroundColor: '#D1EDEC',
    initialsSelectedColor: '#5FC8B0',
    // tabsBorderColor: "#5187F7",
    tabsBorderColor: '#24344b',
    tabBackgroundColor: '#fff',
    tabTextColor: '#424359',
    tabActiveBackgroundColor: '#fff',
    tabActiveTextColor: '#5187f7',
    primaryFontTitleColor: '#0A0E43',
    primaryFontContentColor: '#424359',
    secondaryFontTitleColor: '#0D2938',
    secondaryFontSubtitleColor: '#687883',
    secondaryFontContentColor: '#444E55',
    iconColor: '#24344b',
    iconColorDisabled: 'gray',
    iconColorHeader: '#fff',
    // iconColor: "#5187F7",
    // borderColorPrimary: "#5187F7",
    borderColorPrimary: '#24344b',
    borderColorSecondary: '#ED664F',
    addItemIconColor: '#6CA942', //plus icon color
    selectedItemColor: '#cde1f9',
    selectedAndTimecardItem: '#7fb8f4',
    timeLineNormalColor: '#ff6959',
    timeLineCurrentColor: '#5FC8B0',
    timeLineOtherColor: '#5187F7',
    borderColor: '#b5b5b5',
    itemHeaderSectionBG: '#DEE2E8',
    cardBGColor: '#F2F2F2',
    floatingBGColor: '#FF5555',
    floatingIconColor: '#FFF',
    itemToastColor: '#79DA99',
    highLightItemColor: '#D2F2DC',
    paleGray: '#DEE2E8',
    headerTitleColor: '#6CA942',
    modalBorderColor: '#d3d3d3',
    removeItemBG: '#FFAAAC',
    gray: '#808080',
  },
};
